import { tableHeaderData } from "./tableHeader.data";

import { formatPhoneNumber } from "../../../../../utils/formatPhoneNumber";

import Breadcrumbs from "../../../../common/Breadcrumbs/Breadcrumbs";
import Header from "../../../../layout/Header/Header";
import Footer from "../../../../layout/Footer/Footer";
import BasicTable from "../../../../common/BasicTable/BasicTable";
import UButton from "../../../../common/Button/UButton/UButton";
import BackButton from "../../../../common/Button/BackButton/BackButton";

import {
    getLatesUnepCertificateThunkAction,
} from "../../../../../redux/actions/User/profile/ElectronicSignature/thunk/getLatesUnepCertificate.thunk.action";
import {
    requestUnepPhoneChangeThunkAction,
} from "../../../../../redux/actions/User/profile/ElectronicSignature/thunk/requestUnepPhoneChange.thunk.action";
import {
    confirmUnepPhoneChangeThunkAction,
} from "../../../../../redux/actions/User/profile/ElectronicSignature/thunk/confirmUnepPhoneChange.thunk.action";
import { fetchClaimsThunk } from "../../../../../redux/actions/User/User Claims/thunk/fetchClaimsThunk";
import { Modal } from "../../../../common/Modal/Modal";
import ModalBanOverlay from "../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import ErrorModal from "../../../../common/Modal/ModalConditions/Profile/ErrorModal/ErrorModal";
import PhoneVerify from "../../../../common/Auth/PhoneVerify/PhoneVerify";
import { isTerminal, CLAIMS } from "../../../../../constants";
import { BackArrowButton } from "../../../../common/componentsTerminal/BackArrowButton/BackArrowButton";

import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

isTerminal ? import("./UnepTerminal.scss") : import("./Unep.scss");

const Unep = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const claims = useSelector(state => state.user?.claims);
    const latestCertificate = useSelector(
        (state) => state.personalData.latestCertificate,
    );
    const [errorModal, setErrorModal] = useState(false);
    const [errDescription, setErrDescription] = useState("");

    const [showPhoneVerify, setShowPhoneVerify] = useState(false);
    const [phoneChangeLoading, setPhoneChangeLoading] = useState(false);
    const [bannerError, setBannerError] = useState("");
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [authNumber, setAuthNumber] = useState("");
    const [code, setCode] = useState("");
    const [counter, setCounter] = useState(60);
    const [active, setActive] = useState(false);

    useEffect(() => {
        dispatch(
            getLatesUnepCertificateThunkAction({
                setErrorModal: setErrorModal,
                setErrDescription: setErrDescription,
            }),
        );
        if (!claims || !claims.length) {
            dispatch(fetchClaimsThunk());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function requestPhoneChangeHandler() {
        setBannerError("");
        dispatch(requestUnepPhoneChangeThunkAction(latestCertificate.issueId, {
            setButtonLoading: setPhoneChangeLoading,
            setShowPhoneVerify: setShowPhoneVerify,
            setBannerError: setBannerError,
        }));
    }

    function confirmSubmitHandler(e) {
        e.preventDefault();
        if (code.length === 6) {
            dispatch(confirmUnepPhoneChangeThunkAction(latestCertificate.issueId, code, {
                setLoader: setConfirmLoading,
                setPhoneVerifyVisible: setShowPhoneVerify,
                setAuthNumber: setAuthNumber,
            }));
        }
    }

    return (
        <>
            <Header />
            {claims && claims.length > 0 &&
                claims.find((element)=> !(element === CLAIMS.HAS_DOCUMENTS)) ? (
                    <Breadcrumbs />
                ) : <div style={{ marginTop: "40px" }}>{""}</div>}
            {!isTerminal && <div className={"sub-header"}> УНЭП </div>}
            <section className="unep">
                {isTerminal && (
                    <div className="unep__header">
                        <BackArrowButton />
                        <div className={"sub-header"}> УНЭП</div>
                    </div>
                )}
                {latestCertificate ? (
                    <>
                        <BasicTable
                            dataHeader={tableHeaderData}
                            dataRow={latestCertificate}
                        />
                        {
                            latestCertificate.phoneMismatch && !showPhoneVerify && (
                                <div className={"unep__phone-banner"}>
                                    <div className={"unep__phone-banner__icon"}>i</div>
                                    <div className={"unep__phone-banner__content"}>
                                        <div className={"unep__phone-banner__title"}>
                                            В кадровой системе указан другой номер
                                        </div>
                                        <div className={"unep__phone-banner__phone"}>
                                            {formatPhoneNumber(latestCertificate.bkPhone)}
                                        </div>
                                        <div className={"unep__phone-banner__question"}>
                                            Установить его для подтверждения подписания документов?
                                        </div>
                                        {
                                            bannerError && (
                                                <div className={"unep__phone-banner__error"}>
                                                    {bannerError}
                                                </div>
                                            )
                                        }
                                        <UButton
                                            onClick={requestPhoneChangeHandler}
                                            loading={phoneChangeLoading}
                                            disabled={phoneChangeLoading}
                                        >
                                            установить номер
                                        </UButton>
                                    </div>
                                </div>
                            )
                        }
                        <Modal
                            shown={showPhoneVerify}
                            close={() => setShowPhoneVerify(false)}
                        >
                            <div className="unep__phone-verify-modal">
                                <div className="verification-modal__phone-form">
                                    <PhoneVerify
                                        input={code}
                                        setInput={setCode}
                                        submitHandler={confirmSubmitHandler}
                                        counter={counter}
                                        setCounter={setCounter}
                                        active={active}
                                        setActive={setActive}
                                        styleParent={"verification-modal__phone-form"}
                                        unep
                                        authNumber={authNumber}
                                        approveIdentityWith={requestPhoneChangeHandler}
                                        setToNullAuthNumber={setAuthNumber}
                                        phone={formatPhoneNumber(latestCertificate.certPhone)}
                                        disableSubmit={confirmLoading}
                                    />
                                </div>
                            </div>
                        </Modal>
                        <div className={"unep__container"}>
                            <BackButton
                                disable={claims && claims.length > 0 &&
                                    claims.find((element)=> (element === CLAIMS.HAS_DOCUMENTS))}
                                route={"/profile/eds-release"} />
                            <UButton onClick={() =>
                                navigate(
                                    "/profile/eds-release/unep/release",
                                )
                            }
                            disabled={(latestCertificate.thumbprint && new Date(
                                latestCertificate.issueDate,
                            ) &&
                                         new Date(
                                             latestCertificate.validDate,
                                         ).getTime() > new Date().getTime()) || latestCertificate.status === "Подтверждена" || latestCertificate.status === "В процессе выпуска" || latestCertificate.status === "Выпуск сертификата" || latestCertificate.status === "Требует подтверждения через ГосУслуги" }

                            >{!latestCertificate.thumbprint
                                    ? "получить УНЭП"
                                    : "Перевыпустить УНЭП"
                                }</UButton>

                        </div>
                    </>
                ) : (
                    <>
                        <ClipLoader color="#6DCDF6" />
                    </>
                )}
                <ModalBanOverlay shown={errorModal} close={setErrorModal}>
                    <ErrorModal
                        description={errDescription}
                        setErrorModal={setErrorModal}
                        route={"/profile"}
                    />
                </ModalBanOverlay>
            </section>
            <Footer />
        </>
    );
};

export default Unep;
